import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const setChMobileCookie = () => {
  cookies.set("channel", "ch_mobile", { path: "/", expires: undefined });
};

export const getIsChMobileFromCookie = () => {
  return cookies.get("channel") === "ch_mobile";
};
